import { cn } from "@/lib/utils";

interface FormErrorProps {
  message?: string;
  className?: string;
}

export function FormError({ message, className }: FormErrorProps) {
  if (!message) return null;
  
  return (
    <p className={cn("text-sm text-destructive mt-1.5 animate-in fade-in-0 slide-in-from-top-1 duration-200", className)}>
      {message}
    </p>
  );
}
